exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-buffer-sm {\r\n  margin-top: 20px;\r\n}\r\n\r\n.top-buffer {\r\n  margin-top: 50px;\r\n}\r\n\r\n.tabset-top-buffer {\r\n  margin-top: 20px;\r\n}\r\n\r\n::ng-deep .nav-tabs .nav-link {\r\n  padding: 0 !important;\r\n}\r\n\r\ninput[type=checkbox] {\r\n  display: none;\r\n}\r\n\r\n.wrap-info {\r\n  display: -ms-grid;\r\n  display: grid;\r\n}\r\n\r\n.no-padding {\r\n  padding: 0;\r\n}\r\n\r\n.top-padding {\r\n  padding-top: 16rem;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.dropdown-menu {\r\n  max-height: 300px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.btn-inline {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.toLeft {\r\n  float: left;\r\n}\r\n\r\n.toRight {\r\n  float: right;\r\n}\r\n\r\n.btn-group {\r\n  vertical-align: unset;\r\n}\r\n\r\n@media (max-width: 780px) {\r\n  .col-buffer-bottom {\r\n    margin-bottom: 1rem;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/common/learning/components/start-learning/start-learning.component.css
// module id = ../../../../../src/app/content-page/common/learning/components/start-learning/start-learning.component.css
// module chunks = main